import {
  IAthleteGender,
  IAthleteRole,
  IAthleteRoleGroup,
  IAthleteSport,
  IDrugClass,
  IInquiryStatus,
  IOrganization,
  IRiskLevelDescription,
  ISupplementCategory,
  ISupplementResponseStatus,
} from '@interfaces/lookups';
import { IProgramCode } from '@interfaces/programCodes';
import { IRiskLevel } from '@interfaces/riskLevels';

import { apiUrls } from './urls';
import { get } from './utils';

export const getSupplementCategories = () =>
  get<ISupplementCategory[]>(apiUrls.lookups.supplementCategories);

export const getRiskLevels = () => get<IRiskLevel[]>(apiUrls.lookups.riskLevels);

export const getInquiryStatuses = () => get<IInquiryStatus[]>(apiUrls.lookups.inquiryStatuses);

export const getSupplementResponseStatuses = () =>
  get<ISupplementResponseStatus[]>(apiUrls.lookups.supplementInquiryStatuses);

export const getAthleteGenders = () => get<IAthleteGender[]>(apiUrls.lookups.athleteGenders);

export const getAthleteSports = () => get<IAthleteSport[]>(apiUrls.lookups.athleteSports);

export const getAthleteRoles = (organizationId: number) =>
  get<IAthleteRole[]>(apiUrls.lookups.athleteRoles, { organizationId });

export const getOrganizations = () => get<IOrganization[]>(apiUrls.lookups.organizations);

export const getDrugClasses = () => get<IDrugClass[]>(apiUrls.lookups.drugClasses);

export const getRiskLevelDescriptions = () =>
  get<IRiskLevelDescription[]>(apiUrls.lookups.riskLevelsDescription);

export const getProgramCodes = () => get<IProgramCode[]>(apiUrls.lookups.programCodes);

export const getAthleteRoleGroups = () =>
  get<IAthleteRoleGroup[]>(apiUrls.lookups.athleteRoleGroups);
